export const colorConstants = {
  primaryColor: '#177590',
  secondaryColor: '#F0FBFF',
  secondaryTextColor: '#5B5B5B',
  primaryTextColor: '#1D201F',
  AccentStrokeColor: '#EDEFF2',
  AccentDisabledColor: '#C1C1C1',
  AccentCrossColor: '#A31621',
  AccentTickColor: '#478862',
  AccentInputBgColor: '#F5F9FF',
  AccentTabsBgColor: '#D6F2F9',
  AccentCross: '#C13E18',
  AccentBackgroundWhite: '#FFFFFF',
  AccentAchieveBgNew: '#E7E7E7',
  StrokeGray: '#F2F4F7',
  AccentRainGray: '#E5E5E5',
};

export const fontWeightConstants = {
  bold: 700,
  semibold: 600,
  regular: 400,
};
